// @ts-expect-error TS(2306) FIXME: File '/Users/cedric/Dev/repositories/toktokdoc/wor... Remove this comment to see the full error message
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'
import axios from 'axios'
import { isPasswordValid } from '../utils/validators'

/**
 * @async
 * @description First step, initialise Parse
 * @returns {void}
 */
export const initApi = async () => {
    await ToktokdocLib.Utils.intializeSdk(window._env_.REACT_APP_PARSE_URL, window._env_.REACT_APP_PARSE_APPLICATION_ID)
    ToktokdocLib.Toktokdoc.registerSubclass('_User', ToktokdocLib.User)
}

/**
 * @async
 * @description get the session token from user
 * @returns {string} return token or localtoken
 */
export const getSessionToken = async () => {
    const localToken = await ToktokdocLib.Utils.getSessionToken()

    try {
        await ToktokdocLib.Parse.User.become(localToken)
        return localToken
    } catch (error) {
        try {
            const res = await axios.get(`${window._env_.REACT_APP_HDS_HOST}/login/sessionToken`, {
                withCredentials: true,
            })
            if (res && res.status === 200) {
                return res.data.sessionToken
            }
        } catch {
            return null
        }
    }
    return null
}

/**
 * @async
 * @description Extract login data from token
 *              Legacy login still needed to do update & create with Parse
 * @param {string} token
 * @return {Object}
 */
export const loginParseLegacy = async (token: string) => {
    // calls /me
    const user = await ToktokdocLib.Auth.Login(token)
    return { user }
}

/**
 * @async
 * @description Change the Parse user password
 * @param {string} password the new password
 * @return {Boolean}
 */
export const changeMyPassword = async (password: any) => {
    if (isPasswordValid(password) === true) {
        const user = await ToktokdocLib.Utils.getCurrentUser()
        try {
            const result = await user.save({
                password,
            })
            return result
        } catch (error) {
            // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
            if (error.code === 142) {
                throw new Error('Vous ne pouvez pas utiliser vos précédents mots de passe.')
            }
            throw new Error('Impossible de mettre à jour le mot de passe.')
        }
    }
    return false
}
